import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 20px 0px 0px 0px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 50px;
  margin: 18px 0px;
`;

export const TextButton = styled.div`
  font-size: var(--sm);
  font-weight: var(--medium);
  cursor: pointer;
`;
